import { useLazyQuery } from "@apollo/client/react";import React, { useEffect, useMemo, useState } from 'react';
import './generarMinutaGrilla.scss';
import { Grid } from '@mui/material';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';

import { adaptMinutaItemsEvaluacionArray, GET_MINUTA_ITEMS_EVALUACION } from '../../../data/graphQL/queries/GenerarMinuta/getMinutaItemsEvaluacion';

export const GenerarMinutaDetalleItems = ({
  dataRegistro,
  disabledCheckbox,
  itemsEvaluacion,
  setItemsEvaluacion,
  setItemsSeleccionados,
  refetchConexiones,
  setRefetchConexiones,
  recalcularPrecio
}) => {
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [getItems, { data: dataItems, loading: itemsEvaluacionLoading }] = useLazyQuery(GET_MINUTA_ITEMS_EVALUACION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataItems) return;
    setItemsEvaluacion(adaptMinutaItemsEvaluacionArray(dataItems.conexionesEvaluacionMinuta));
    setRefetchConexiones(false);
  }, [dataItems]);

  useEffect(() => {
    if (!itemsEvaluacionLoading)
    getItems({variables: {
      filter: {
        idEvaluacion: dataRegistro?.idEvaluacion,
        fechaDesde: dataRegistro?.fechaDesdeMin,
        fechaHasta: dataRegistro?.fechaHastaMax
      }
    }});
  }, []);

  useEffect(() => {
    if (refetchConexiones && !itemsEvaluacionLoading)
    getItems({variables: {
      filter: {
        idEvaluacion: dataRegistro?.idEvaluacion,
        fechaDesde: dataRegistro?.fechaDesdeMin,
        fechaHasta: dataRegistro?.fechaHastaMax
      }
    }});
  }, [refetchConexiones]);

  useEffect(() => {
    if (!itemsEvaluacionLoading)
    recalcularPrecio();
  }, [itemsEvaluacion]);

  const handleSelectionModelChange = (ids) => {
    setRowSelectionModel(ids);
    if (ids.length > 0) {
      setItemsSeleccionados(itemsEvaluacion.filter((row, index) => {
        return ids.includes(index + 1);
      }));
    } else {
      setItemsSeleccionados([]);
    }
  };

  const initialColumns = [
  {
    field: 'idConexion',
    headerName: 'Conexión',
    headerAlign: 'center',
    align: 'center',
    flex: 0.10
  },
  {
    field: 'fechaConexion',
    headerName: 'Fecha Conexión',
    headerAlign: 'left',
    align: 'left',
    type: 'date'
  }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), []);

  return (
    <>
            <Grid container spacing={1} sx={{ marginTop: '10px' }}>
                <Grid size={{ xs: 12, md: 12 }}>
                    <div className='section-title'>Items de la Evaluación</div>
                    <DataGridGenerico
            columns={columns}
            rows={itemsEvaluacion}
            toolbar={false}
            maxWidth={columns.reduce(
              (total, column) => total + (column.width || 0),
              0
            )}
            checkboxSelection
            isRowSelectable={(param) => !disabledCheckbox(param.row)}
            onRowSelectionModelChange={handleSelectionModelChange}
            rowSelectionModel={rowSelectionModel}
            loading={itemsEvaluacionLoading} />
          
                </Grid>
            </Grid>
        </>);

};